'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'glass-water-droplet';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e4f5';
var svgPathData = 'M32.5 40.7c-.4-4.7 3.3-8.7 8-8.7l303.7 0c4.7 0 8.4 4 8 8.7l-22.3 264.7-23.9 12c-19.2 9.6-42.3 7.2-59.1-6.3-31.8-25.5-77.1-25.5-108.9 0-16.8 13.4-39.9 15.9-59.1 6.3l-24-12-22.3-264.6zM58 342.7l6.6 3.3c30.4 15.2 66.9 11.3 93.4-9.9 20.1-16.1 48.8-16.1 68.9 0 26.5 21.2 63 25.1 93.4 9.9l6.5-3.2-9.1 108c-1.4 16.6-15.3 29.3-31.9 29.3L99 480c-16.6 0-30.5-12.7-31.9-29.3L58 342.7zM40.5 0C17.1 0-1.3 20 .6 43.4l34.6 410C38 486.5 65.7 512 99 512l186.8 0c33.3 0 61-25.5 63.8-58.6l34.6-410C386.1 20 367.6 0 344.2 0L40.5 0zM192.4 216c-19.6 0-32-14.5-32-28 0-6.6 4.3-19 14.8-35.6 5.4-8.5 11.4-16.7 17.2-24 5.8 7.3 11.9 15.5 17.2 24 10.5 16.6 14.8 29 14.8 35.6 0 13.5-12.3 28-32 28zm0 32c35.3 0 64-26.9 64-60 0-32.5-34.8-75.8-53.1-96.3-5.9-6.6-15.9-6.6-21.8 0-18.3 20.5-53.1 63.9-53.1 96.3 0 33.1 28.7 60 64 60z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGlassWaterDroplet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;